import { render, staticRenderFns } from "./RComponentHeader.vue?vue&type=template&id=af0c3d7e&scoped=true&"
import script from "./RComponentHeader.vue?vue&type=script&lang=js&"
export * from "./RComponentHeader.vue?vue&type=script&lang=js&"
import style0 from "./RComponentHeader.vue?vue&type=style&index=0&id=af0c3d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c3d7e",
  null
  
)

export default component.exports